import apiClient from '@/services/AccountClient'

export default {
  fetchAllPairs (params = {}, options) {
    return apiClient.sendRequest(
      'GET',
      'api/admin/v1/fx-rates',
      params,
      options
    )
  },
  savePair (data) {
    return apiClient.sendRequest(
      'PUT',
      'api/admin/v1/fx-rates',
      data
    )
  },
  deletePair (fromCurrency, toCurrency) {
    return apiClient.sendRequest(
      'DELETE',
      `api/admin/v1/fx-rates/${fromCurrency}/${toCurrency}`
    )
  },
  enableRate (currencyRateId, enabled) {
    return apiClient.sendRequest(
      'PUT',
      `api/admin/v1/fx-rates/${currencyRateId}/enable`,
      { enabled }
    )
  }
}
